var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'overflow-hidden': _vm.isOverflow }},[_c('nuxt'),_vm._v(" "),(_vm.isCookiesDisclaimerVisible)?_c('panel-cookies',{on:{"accept":_vm.onCookiesAccept}}):_vm._e(),_vm._v(" "),(_vm.isAuthVisible)?_c('auth'):_vm._e(),_vm._v(" "),(_vm.$auth.loggedIn)?_c('activation'):_vm._e(),_vm._v(" "),_c('search-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }